<hr class="rds-divider-inline" />
<footer
  class="rds-padding-150 rds-display-flex rds-justify-content-between rds-align-items-center rds-body-color-background-subtle">
  <h2 class="rds-heading-2 logo rds-margin-block-end-0">Rabobank</h2>
  <span>
    <a
      href="https://www.rabobank.com/privacy"
      target="_blank"
      class="rds-link rds-link-icon rds-margin-inline-end-150">
      Privacy Statement
      <rds-icon
        name="rds-icon-box-arrow-up-right"
        size="xs"
        class="rds-margin-inline-start-25"></rds-icon>
    </a>
    <a
      href="https://www.rabobank.com/conditions"
      target="_blank"
      class="rds-link rds-link-icon">
      Disclaimer
      <rds-icon
        name="rds-icon-box-arrow-up-right"
        size="xs"
        class="rds-margin-inline-start-25"></rds-icon>
    </a>
  </span>
</footer>
